module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_int.htm"
    }
  }, [_c('strong', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_equ.htm"
    }
  }, [_c('strong', [_vm._v("Equipment")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/5-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c01.htm"
    }
  }, [_c('strong', [_vm._v("CHAPTER 1: CONTROLLING EXPOSURE BY DARWIN WIGGETT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c01.htm#a01"
    }
  }, [_c('strong', [_vm._v("The RAW advantage")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c01.htm#a02"
    }
  }, [_c('strong', [_vm._v("Aperture choice and the WO-M-EN concept")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c01.htm#a03"
    }
  }, [_c('strong', [_vm._v("Using the histogram")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c01.htm#a04"
    }
  }, [_c('strong', [_vm._v("Fixing a broken histogram")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c01.htm#a05"
    }
  }, [_c('strong', [_vm._v("Post-production contrast control")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/5-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c02.htm"
    }
  }, [_c('strong', [_vm._v("CHAPTER 2: UNDERSTANDING LIGHT BY DAVID NOTON")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c02.htm#a06"
    }
  }, [_c('strong', [_vm._v("A feel for light")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c02.htm#a07"
    }
  }, [_c('strong', [_vm._v("Time of day: from dawn to dusk")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c02.htm#a08"
    }
  }, [_c('strong', [_vm._v("Colour temperature: use it or lose it")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c02.htm#a09"
    }
  }, [_c('strong', [_vm._v("Colour quality: full-throttle or watercolour?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c02.htm#a10"
    }
  }, [_c('strong', [_vm._v("A sense of direction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c02.htm#a11"
    }
  }, [_c('strong', [_vm._v("Weather: dodging the rain clouds")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/5-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c03.htm"
    }
  }, [_c('strong', [_vm._v("CHAPTER 3: COMPOSING LANDSCAPE IMAGES BY WILLIAM NEILL")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c03.htm#a12"
    }
  }, [_c('strong', [_vm._v("Using the frame")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c03.htm#a13"
    }
  }, [_c('strong', [_vm._v("Order out of chaos")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c03.htm#a14"
    }
  }, [_c('strong', [_vm._v("Depth in the landscape")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c03.htm#a15"
    }
  }, [_c('strong', [_vm._v("Cropping")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c03.htm#a16"
    }
  }, [_c('strong', [_vm._v("Working the scene")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c03.htm#a17"
    }
  }, [_c('strong', [_vm._v("Creating a panorama")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c03.htm#a18"
    }
  }, [_c('strong', [_vm._v("Description vs. interpretation")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/5-4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c04.htm"
    }
  }, [_c('strong', [_vm._v("CHAPTER 4: LANDSCAPE LOCATIONS BY TOM MACKIE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c04.htm#a19"
    }
  }, [_c('strong', [_vm._v("Research and planning")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c04.htm#a20"
    }
  }, [_c('strong', [_vm._v("Water in the landscape")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c04.htm#a21"
    }
  }, [_c('strong', [_vm._v("Mountains")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c04.htm#a22"
    }
  }, [_c('strong', [_vm._v("Deserts and wilderness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c04.htm#a23"
    }
  }, [_c('strong', [_vm._v("Forests and woodland")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c04.htm#a24"
    }
  }, [_c('strong', [_vm._v("Urban landscapes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c04.htm#a25"
    }
  }, [_c('strong', [_vm._v("Exploring your local landscape")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c04.htm#a26"
    }
  }, [_c('strong', [_vm._v("Changing the sky")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/5-5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c05.htm"
    }
  }, [_c('strong', [_vm._v("CHAPTER 5: LANDSCAPES IN BLACK AND WHITE BY TONY WOROBIEC")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c05.htm#a27"
    }
  }, [_c('strong', [_vm._v("The black and white mindset")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c05.htm#a28"
    }
  }, [_c('strong', [_vm._v("In-camera settings for black and white")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c05.htm#a29"
    }
  }, [_c('strong', [_vm._v("Converting colour to monochrome")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c05.htm#a30"
    }
  }, [_c('strong', [_vm._v("Non-destructive dodging and burning")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c05.htm#a31"
    }
  }, [_c('strong', [_vm._v("Sepia toning")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c05.htm#a32"
    }
  }, [_c('strong', [_vm._v("Blue toning using duotone")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c05.htm#a33"
    }
  }, [_c('strong', [_vm._v("Dual toning using selective colour")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c05.htm#a34"
    }
  }, [_c('strong', [_vm._v("Creating a lith effect")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_c05.htm#a35"
    }
  }, [_c('strong', [_vm._v("Simulating hand-colouring digitally")])])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_ata.htm"
    }
  }, [_c('strong', [_vm._v("Author biographies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_ind.htm"
    }
  }, [_c('strong', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9781446352496_epub_ack.htm"
    }
  }, [_c('strong', [_vm._v("Acknowledgments")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78fc9657","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781446352496_epub_toc.vue
// module id = 63
// module chunks = 0